import { LspWsConnection, CodeMirrorAdapter } from 'lsp-codemirror'
import "codemirror/addon/hint/show-hint.js"

export default {
  data: () => ({
    retryTimer: null,
    javascriptAdapter: null,
    javascriptConnection: null,
    socketLsp: null,
    refLsp: null,
    modeLsp: null
  }),
  methods: {
    getCodemirrorRef(ref) {
      if(Array.isArray(this.$refs[ref]) && this.$refs[ref][0].$refs[ref])
        return this.$refs[ref][0].$refs[ref].codemirror
      else if(this.$refs[ref] && this.$refs[ref].codemirror)
        return this.$refs[ref].codemirror
      else if(this.$refs[ref] && this.$refs[ref].$refs[ref])
        return this.$refs[ref].$refs[ref].codemirror
      else
        return null
    },
    getCodemirrorComponentRef(ref) {
      if(this.$refs[ref] && this.$refs[ref].codemirror)
        return this.$refs[ref]
      else if(this.$refs[ref] && this.$refs[ref].$refs[ref].codemirror)
        return this.$refs[ref].$refs[ref]
      else
        return null
    },
    replaceCodemirrorValue(ref, value) {
      let editor = this.getCodemirrorRef(ref)
      if(editor){
        let doc = editor.getDoc();
        let cursor = doc.getCursor();
        doc.replaceRange(value, cursor);
      }
    },
    setCodemirrorValue(ref, value) {
      let editor = this.getCodemirrorRef(ref)
      if(editor){
        let doc = editor.getDoc();
        let cursor = doc.getCursor();
        doc.setValue(value, cursor)
      }
    },
    refreshCodemirror(ref) {
      if(this.getCodemirrorComponentRef(ref)){
        let codemirror = this.getCodemirrorComponentRef(ref).$el.querySelector('.CodeMirror')
        codemirror.CodeMirror.refresh()
      }
    },
    closeLsp(){
      if (this.javascriptAdapter) {
        this.javascriptAdapter.remove();
        this.javascriptAdapter = null;
      }
      if (this.socketLsp) {
        this.socketLsp.close();
        this.socketLsp = null;
      }
      if (this.javascriptConnection && !this.javascriptConnection.isDisposed) {
        this.javascriptConnection.close();
      }
      this.refLsp = null;
      this.modeLsp = null;
    },
    startLsp(ref, mode = 'groovy') {
      let editor = this.getCodemirrorRef(ref);
      this.refLsp = ref;
      this.modeLsp = mode;
      this.socketLsp = new WebSocket(`wss://mutant-lsp.plataformaidt.io/${ mode }`)

      if (this.javascriptAdapter) {
        try { this.javascriptAdapter.remove(); } catch (e) { /* ignore */ }
      }

      this.javascriptConnection = new LspWsConnection({
        serverUri: `wss://mutant-lsp.plataformaidt.io/${ mode }`,
        mode: mode,
        documentUri: `file:///tmp/lsp-ws/test.${ mode }`,
        documentText: () => editor.getValue(),
      }).connect(this.socketLsp);

      this.javascriptConnection.on('error', (message) => {
        if (message.includes('disposed') || message[0].message.includes('code = 1006')) {
          this.retryConnection();
        } else {
          this.closeLsp()
        }
      });

      this.socketLsp.onclose = () => {
        this.retryConnection();
      };

      this.javascriptAdapter = new CodeMirrorAdapter(this.javascriptConnection, {
        quickSuggestionsDelay: 25,
      }, editor);
    },
    retryConnection() {
      clearTimeout(this.retryTimer);
      this.retryTimer = setTimeout(() => {
        this.startLsp(this.refLsp, this.modeLsp);
      }, 3000);
    },
  }
};
